"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadsNotSeenDashboardDTO = exports.UploadsNotSeenSchema = exports.ApproveSSTDashboardDataSchema = exports.ApprovedSSTDataSchema = exports.DashboardMemberDTOSchema = void 0;
var zod_1 = require("zod");
exports.DashboardMemberDTOSchema = zod_1.z.object({
    email: zod_1.z.string(),
    fullName: zod_1.z.string(),
    image: zod_1.z.string().optional(),
    _id: zod_1.z.coerce.string(),
});
exports.ApprovedSSTDataSchema = zod_1.z.object({
    date: zod_1.z.string(), // You can further refine this if the date format is strict
    value: zod_1.z.number(),
});
exports.ApproveSSTDashboardDataSchema = zod_1.z.object({
    today: zod_1.z.number(),
    week: zod_1.z.number(),
    month: zod_1.z.number(),
    total: zod_1.z.number(),
    data: zod_1.z.array(exports.ApprovedSSTDataSchema), // Use the schema for `ApprovedSSTData`
});
exports.UploadsNotSeenSchema = zod_1.z.object({
    createdAt: zod_1.z.date(),
    fullName: zod_1.z.string(),
    AuthorId: zod_1.z.coerce.string(),
    UploadName: zod_1.z.string(),
});
exports.UploadsNotSeenDashboardDTO = {
    convertFromModel: function (model, geUploadName) {
        return {
            createdAt: new Date(model.createdAt),
            fullName: model.user.fullName,
            AuthorId: model.user._id.toString(),
            UploadName: geUploadName(model),
        };
    },
};
//# sourceMappingURL=Dashboard.js.map